// extracted by mini-css-extract-plugin
export default {"wrapper":"viewer_wrapper__a4aRp","img":"viewer_img__Fw88L","menu":"viewer_menu__A2YkG","cta":"viewer_cta__z2anF"};